"use client";

import { CSSProperties, useMemo } from "react";
import classes from "./ProductRowSlider.module.css";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import ProductCard from "@/components/ProductCard";
import ArrowBoxButton from "@/components/buttons/ArrowBoxButton";
import { ProductRowSkeleton } from "../skeleton";

interface Props {
  className?: string;
  style?: CSSProperties;

  colLimit?: number;
  products?: ProductItem[];
  animated?: boolean;
  loading?: boolean;

  settings?: WidgetSettings;

  uid?: string;
}

const ProductRowSlider = ({
  className,
  style,

  colLimit = 5,
  products = [],
  animated = false,
  loading = false,

  settings = {},

  uid = "uid",
}: Props) => {
  const classNames = [classes.ProductRowSlider, className];

  const randomKey = useMemo(
    () => uid,
    [uid]
  );

  // console.log("product data",products)

  return (
    <div className={classNames.join(" ")} style={style}>
      <div className={classes.changer}>
        <ArrowBoxButton
          key={"prev-" + randomKey}
          type="left"
          className={`${classes.button} ${classes.left}`}
          id={"prev-featured-" + randomKey}
        />

        <ArrowBoxButton
          key={"next-" + randomKey}
          type="right"
          className={`${classes.button} ${classes.right}`}
          id={"next-featured-" + randomKey}
        />
      </div>

      <Swiper
        key={randomKey}
        spaceBetween={8}
        navigation={{
          nextEl: "#next-featured-" + randomKey,
          prevEl: "#prev-featured-" + randomKey,
        }}
        breakpoints={{
          500: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          800: {
            slidesPerView: Math.min(colLimit - 1, 3),
            spaceBetween: 12,
          },
          1200: {
            slidesPerView: colLimit,
            spaceBetween: 12,
          },
        }}
        autoplay={
          settings?.autoplay
            ? {
                delay: settings?.delay || 3500,
                disableOnInteraction: false,
              }
            : false
        }
        // autoplay={{
        // 	delay: 1000,
        // }}
        slidesPerView={2}
        slidesPerGroup={3}
        speed={700}
        pagination={{
          clickable: true,
        }}
        className={classes.swiper}
        modules={[Navigation, Autoplay]}
      >
        {products.map((product, i) => (
          <SwiperSlide
            key={animated ? product.id + "-" + i : i}
            className={classes.slide}
          >
            <div
              className={`${
                animated ? classes.animated : ""
              }`}
            >
              <ProductCard productItem={product} type="lg" />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {loading && <ProductRowSkeleton />}
    </div>
  );
};

export default ProductRowSlider;
